import React, { useState } from 'react';
import Login from './components/Login/Login';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import './App.css';
import { CountryProvider } from './contexts/CountryContext';
import { DataProvider } from './contexts/dataContext';
import GrabTopline from './pages/GrabTopline';
function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentView, setCurrentView] = useState('home');
  const [currentProject, setCurrentProject] = useState(null);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleProjectSelect = (project,pagedisplay) => {
    setCurrentProject(project);
    setCurrentView(pagedisplay || 'dashboard');
  };

  const handleNavigation = (view) => {
    setCurrentView(view);
  };

  if (!isLoggedIn) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="app-container">
      <main className="main-content">
        <CountryProvider>
          <DataProvider>
          {currentView === 'home' && (
            <Home 
              onProjectSelect={handleProjectSelect}
              onNavigation={handleNavigation}
            />
          )}
          {currentView === 'dashboard' && currentProject && (
            <Dashboard project={currentProject} onNavigation={handleNavigation} />
          )}
          {currentView === 'grabtopline' && currentProject && (
            <GrabTopline project={currentProject} onNavigation={handleNavigation} />
          )}
          {currentView === 'users' && <UserManagement onNavigation={handleNavigation} />}
        </DataProvider>
        </CountryProvider>
      </main>
    </div>
  );
}

export default App;